import { FirstDayOfWeek, getBrowserTimezone, getLocaleFirstDayOfWeek } from '../../utils/date';
import { storage_keys } from '../../utils/storage';
import useLocalStorage from './useLocalStorage';

export const useDatePreferences = () => {
  const [timezone_preference] = useLocalStorage<string | null>(storage_keys.timezone, null);
  const [first_day_of_week_preference] = useLocalStorage<FirstDayOfWeek | null>(
    storage_keys.first_day_of_week,
    null,
  );
  const browser_timezone = getBrowserTimezone();
  const locale_first_day_of_week = getLocaleFirstDayOfWeek();

  return {
    timezone: timezone_preference ?? browser_timezone,
    timezone_preference,
    first_day_of_week: first_day_of_week_preference ?? locale_first_day_of_week,
    first_day_of_week_preference,
    browser_timezone,
    locale_first_day_of_week,
    uses_browser_timezone: timezone_preference == null,
    uses_locale_first_day_of_week: first_day_of_week_preference == null,
  };
};

export const useUpdateTimezonePreference = () => {
  const [, setTimezonePreference] = useLocalStorage<string | null>(storage_keys.timezone, null);

  return async (timezone: string | null) => {
    setTimezonePreference(timezone);
  };
};

export const useUpdateFirstDayOfWeekPreference = () => {
  const [, setFirstDayOfWeekPreference] = useLocalStorage<FirstDayOfWeek | null>(
    storage_keys.first_day_of_week,
    null,
  );

  return async (first_day_of_week: FirstDayOfWeek | null) => {
    setFirstDayOfWeekPreference(first_day_of_week);
  };
};
